<template>
    <div class="panel fx-g1" >
        <el-form ref="form" :model="form" label-width="150px" class="edit_form fx fx-m_center" style="width: 100%">
            <div style="width: 500px">
                <el-form-item label="是否开启校区官网">
                    <text-switch on-text="启用" off-text="不启用" v-model="form.enable"></text-switch>
                </el-form-item>
                <el-form-item label="网站标题">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="网站Logo">
                    <el-upload
                        v-loading="logo_uploading"
                        element-loading-text="上传中..."
                        class="photo_uploader institution_logo"
                        action=""
                        accept="image/*"
                        :show-file-list="false"
                        :before-upload="uploadLogo">
                        <img v-if="form.logo != null" :src="form.logo" class="avatar">
                        <i v-else class="el-icon-plus uploader-icon"></i>
                    </el-upload>
                    <span class="text_info">上传logo图片，145*60px最佳</span>

                </el-form-item>
                <el-form-item label="搜索关键词">
                    <el-input v-model="form.keywords"></el-input>
                </el-form-item>
                <el-form-item label="网站介绍">
                    <el-input v-model="form.description" type="textarea" ></el-input>
                </el-form-item>
<!--                <el-form-item label="是否使用定制网页">-->
<!--                    <text-switch on-text="启用" off-text="不启用" v-model="form.customizePage"></text-switch>-->
<!--                </el-form-item>-->
                <el-form-item v-if="form.customizePage" label="网页地址">
                    <el-input v-model="form.htmlpath"></el-input>
                </el-form-item>
            </div>
            <div style="width: 500px">
                <el-form-item label="网站底部二维码">
                    <el-upload
                        v-loading="qrcode_uploading"
                        element-loading-text="上传中..."
                        class="photo_uploader "
                        action=""
                        accept="image/*"
                        :show-file-list="false"
                        :before-upload="uploadQrcode">
                        <img v-if="form.qrcode != null" :src="form.qrcode" class="avatar">
                        <i v-else class="el-icon-plus uploader-icon"></i>
                    </el-upload>

                </el-form-item>
                <el-form-item label="网站底部预留电话">
                    <el-input v-model="form.phone"></el-input>
                </el-form-item>
                <el-form-item label="网站底部预留地址">
                    <el-input v-model="form.address"></el-input>
                </el-form-item>
                <el-form-item label="备案号">
                    <el-input v-model="form.sn"></el-input>
                </el-form-item>


            </div>

        </el-form>
        <div class="fx fx-center" style="padding: 20px">
            <el-button type="primary" @click="sub">保存</el-button>
        </div>

    </div>
</template>


<style scoped>
    .institution_logo .uploader-icon {
        width: 145px;
        height: 60px;
        line-height: 60px;
    }
    .avatar {
        width: 145px;
        height: 60px;
    }
</style>
<style>
    .institution_logo  .el-upload{
        width: 150px;
        height: 60px;
    }
</style>

<script>


    export default {
        props: [
            "attr",
        ],
        data() {
            return {
                logo_uploading:false,
                qrcode_uploading:false,
                form: { },
                config: {},
            }

        },


        methods: {
            loadData() {
                this.$ajaxGet("/config/getWebsiteBaseInfo", (data) => {
                    this.form = data.result.value ?  JSON.parse(data.result.value) : {};
                    this.config = data.result ? data.result : {};
                })
            },
            uploadLogo(file) {
                this.logo_uploading = true;
                this.$uploadQiniu(file, "website/", {
                        success: (file) => {
                            this.form = Object.assign({}, this.form, {logo: file.url});
                            this.logo_uploading = false;
                        }
                    }
                )

                return false;
            },
            uploadQrcode(file) {
                this.qrcode_uploading = true;
                this.$uploadQiniu(file, "website/", {
                        success: (file) => {
                            this.form = Object.assign({}, this.form, {qrcode: file.url});
                            this.qrcode_uploading = false;
                        }
                    }
                )

                return false;
            },
            sub() {
                this.$ajaxPost("/config/saveConfig", {
                    config: {...this.config, type: 1, value: JSON.stringify(this.form)}
                }, data => {
                    this.$showSuccess("保存成功");
                })
            }

        },
        mounted() {
        },
        created() {
            this.loadData() ;
        }


    }
</script>
